import * as Comlink from 'comlink';
import debounce from 'debounce-promise';

import { DrumHit } from '../core';

/* eslint-disable import/no-webpack-loader-syntax */
const Worker = require('worker-loader!./worker').default;

let workerRef: Comlink.Remote<any>;

async function init() {
    if (!workerRef) {
        let worker = new Worker();
        workerRef = Comlink.wrap(worker);
    }
}

export let generateVariationSequence = debounce(async (drumSequence: readonly DrumHit[], timeSteps: number): Promise<DrumHit[]> => {
    init();
    return workerRef.generateVariation(drumSequence, timeSteps);
}, 1000);